import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'allas-top-footer',
  imports: [CommonModule],
  template: `
    <section
      class="bg-[#121826] xl:bg-[#2b384b] flex flex-col xl:flex-row gap-4 xl:gap-28 items-center justify-center p-6"
      aria-label="Enlaces rápidos y redes sociales"
    >
      <nav
        class="flex flex-col xl:flex-row gap-4 xl:gap-8 w-full xl:w-max"
        aria-label="Enlaces de navegación rápida"
      >
        <ng-container
          *ngTemplateOutlet="
            actionLink;
            context: {
              href: '/encuentra-tu-tienda',
              icon: '/allas-icons/store-new-red.svg',
              iconAlt: 'Icono de tienda',
              text: 'Encuentra una Tienda',
              iconClass: 'w-5 h-5'
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            actionLink;
            context: {
              href: '/repuestos/bateria-para-carro-auto-o-camioneta',
              icon: '/allas-icons/battery.svg',
              iconAlt: 'Icono de batería',
              text: 'Encuentra tu Batería',
              iconClass: 'w-auto h-5'
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            actionLink;
            context: {
              href: '/empresa/bolsa-empleo',
              icon: '/allas-icons/hiring.svg',
              iconAlt: 'Icono de empleo',
              text: 'Estamos Contratando',
              iconClass: 'w-auto h-6'
            }
          "
        ></ng-container>
      </nav>

      <nav class="flex gap-6 items-center" aria-label="Redes sociales">
        <ng-container
          *ngTemplateOutlet="
            socialLink;
            context: {
              href: 'https://www.facebook.com/AllasRepuestoshn/',
              icon: '/allas-icons/new-facebook.svg',
              alt: 'Facebook',
              platform: 'Facebook'
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            socialLink;
            context: {
              href: 'https://www.instagram.com/allasrepuestos/',
              icon: '/allas-icons/new-Instagram.svg',
              alt: 'Instagram',
              platform: 'Instagram'
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            socialLink;
            context: {
              href: 'https://www.tiktok.com/@allasrepuestoshn',
              icon: '/allas-icons/tiktok.svg',
              alt: 'TikTok',
              platform: 'TikTok'
            }
          "
        ></ng-container>
      </nav>
    </section>

    <!-- Templates -->
    <ng-template
      #actionLink
      let-href="href"
      let-icon="icon"
      let-iconAlt="iconAlt"
      let-text="text"
      let-iconClass="iconClass"
    >
      <a
        [href]="href"
        class="flex gap-2 items-center bg-[#2b384b] p-4 justify-center w-full xl:w-max hover:bg-opacity-80 transition-colors"
        [attr.aria-label]="'Ir a ' + text"
      >
        <img
          [src]="icon"
          [alt]="iconAlt"
          [class]="iconClass"
          loading="lazy"
          width="20"
          height="20"
        />
        <span>{{ text }}</span>
      </a>
    </ng-template>

    <ng-template
      #socialLink
      let-href="href"
      let-icon="icon"
      let-alt="alt"
      let-platform="platform"
    >
      <a
        [href]="href"
        class="hover:opacity-80 transition-opacity"
        [attr.aria-label]="'Síguenos en ' + platform"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          [src]="icon"
          [alt]="alt"
          class="w-5 h-5"
          loading="lazy"
          width="20"
          height="20"
        />
      </a>
    </ng-template>
  `,
})
export class TopFooterComponent {}
